<template>
	<div class="update">
		<!-- <h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">礼品卡 </h2> -->

		<div class="search" @keyup.enter="getList">
			<div class="search-left">
				<div class="search-title">序列号范围：</div>
				<el-input v-model="sn_start" onkeyup="value=value.replace(/[^\d]/g,'')" class="qjc-fts-14 " placeholder="开始序列"></el-input>
				<span class="search-line">—</span>
				<el-input v-model="sn_end" onkeyup="value=value.replace(/[^\d]/g,'')" class="qjc-fts-14" placeholder="结束序列"></el-input>
			</div>
			<el-button @click="getList" :loading="submiting" class="qjc-fts-16">筛选</el-button>
		</div>

		<el-table
			ref="cardTabel"
			@header-click="headerChange"
			:data="list"
			class="list qjc-fts-14"
			@filter-change="filterChange"
			header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark"
			@selection-change="handleSelectionChange" >
			
			<!-- :height="mainHeight" -->
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="sn" label="序列号" width="150px" class-name="sn"></el-table-column>
			<el-table-column prop="code" label="礼品码" width="150px" class-name="code"></el-table-column>
			<el-table-column prop="enable" label="状态" width="150px" class-name="enable" :filter-multiple="false" column-key="enable" :filters="enableList">
				<template slot-scope="scope">
					<div class="remarks-tabel">
						<div>{{ scope.row.enable == '1' ? '未使用' : scope.row.enable == '2' ? '已使用' : scope.row.enable == '0' ? '已冻结' : '未知' }}</div>
						<el-tooltip v-if="scope.row.enable == '2'" popper-class="status-popper" class="item" effect="light" placement="right-end">
							<el-button class="status-tag">详情</el-button>
							<div class="status-tip-text" slot="content">
								使用用户：{{ scope.row.user_id }}
								<br />
								使用时间：{{ scope.row.used_at }}
							</div>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="销售员" width="150px" class-name="mobile">
				<template slot-scope="scope">
					<div class="remarks-tabel">
						<div>{{ scope.row.mobile ? scope.row.mobile : '--' }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="order_no" label="订单号码" class-name="order_no">
				<template slot-scope="scope">
					{{ scope.row.order_no ? scope.row.order_no : '--' }}
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" class-name="remark" column-key="remark" :filter-multiple="false" :filters="remarkList">
				<template slot-scope="scope">
					<div class="remarks-tabel">
						<el-input
							class="remarks-input"
							v-model="scope.row.remark"
							v-show="reviseId == scope.row.id"
							placeholder="请备注"
							@blur="handleRemarkBlur"
							@keyup.enter.native="$event.target.blur"
						></el-input>
						<div class="remarks-val" v-show="reviseId != scope.row.id">{{ scope.row.remark }}</div>
						<div class="remarks-icon" @click="handleReviseRemark(scope.row)"><i class="el-icon-edit icon-hover"></i></div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- 批量修改备注弹窗 -->
		<el-dialog title="批量修改备注" :visible.sync="remarkPopupShow" :show-close="false" :close-on-click-modal="false" width="30%">
			<el-input class="" v-model="batchRemark" placeholder="请输入备注"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button type="info" @click="handleClosePopup">取 消</el-button>
				<el-button type="primary" @click="handleBatchRemark">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 批量解冻礼品卡弹窗 -->
		<el-dialog title="批量解冻礼品卡" :visible.sync="thawPopupShow" :show-close="false" :close-on-click-modal="false" width="30%">
			<div class="">是否确定批量解冻礼品卡？</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="info" @click="handleCloseThaw">取 消</el-button>
				<el-button type="primary" @click="handleBatchThaw">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 批量冻结礼品卡弹窗 -->
		<el-dialog title="批量冻结礼品卡" :visible.sync="frozenPopupShow" :show-close="false" :close-on-click-modal="false" width="30%">
			<div class="">是否确定批量冻结礼品卡？</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="info" @click="handleCloseFrozen">取 消</el-button>
				<el-button type="primary" @click="handleBatchFrozen">确 定</el-button>
			</span>
		</el-dialog>
		<div class="select-cell">
			<!-- 底部数据批量处理选择器 -->
			<div>
				<!-- <el-checkbox class="check-all" v-model="allChecked" @change="handleAll">全部选择</el-checkbox> -->
				<el-select v-model="selectValue" :disabled="selectList && selectList.length <= 0" placeholder="请选择" @change="handleSelectAction">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<!-- 分页组件 -->
			<el-pagination
				class="pagination qjc-texta-c"
				layout="prev, pager, next"
				hide-on-single-page
				:current-page.sync="pageData.page"
				:page-count="pageData.pagecount"
				:page-size="pageData.pagesize"
				:total="pageData.count"
				@current-change="pageChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { getGiftCardList, getGiftRemark } from '@/utils/axios.js';

export default {
	name: 'mainGiftCard',
	data() {
		return {
			submiting: false, // 正在请求
			list: [], //列表
			pageData: {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 15 // 每页条数
			},
			sn_start: '', //序号筛选起始值
			sn_end: '', //序号筛选结束值
			reviseId: '', //当前选中Id
			remarkList: [], //备注筛选列表
			remarkValue: '', //选中备注值 筛选
			enableValue: '', //选中状态值 筛选
			selectList: [], //选中Id列表
			enableList: [{ text: '未使用', value: '1' }, { text: '已使用', value: '2' }, { text: '已冻结', value: '3' }], // 状态筛选列表
			options: [
				{ value: '取消', label: '取消' },
				{ value: '冻结礼品卡', label: '冻结礼品卡' },
				{ value: '解冻礼品卡', label: '解冻礼品卡' },
				{ value: '批量修改备注', label: '批量修改备注' }
			], // 批量操作列表
			selectValue: '', //批量选择选中值
			oldRemark: '', //当前选中备注值
			allChecked: false, //底部是否全选
			remarkPopupShow: false, //批量修改备注弹窗
			thawPopupShow: false, //批量解冻礼品卡弹窗
			frozenPopupShow: false, //批量解冻礼品卡弹窗
			batchRemark: '', //批量修改备注值
			mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 250 ,// 容器最小高度(去除header高度)
		};
	},

	mounted() {
		this.getList();
	},
	components: {},
	watch: {},
	methods: {
		// 获取备注筛选列表
		headerChange(column, event) {
			//判断头部点击是否为备注项
			if (column.property == 'remark') {
				getGiftRemark({ act: 'query' }).then(res => {
					if (res.code == 200) {
						let list = res.data;
						this.remarkList = [];
						list.map(item => {
							let obj = {
								text: item.remark,
								value: item.remark
							};
							this.remarkList.push(obj);
						});
					} else {
						this.$message.error(res.msg);
					}
				});
			}
		},
		//批量操作处理
		handleSelectAction(val) {
			this.selectValue = val;
			if (val == '冻结礼品卡') {
				this.frozenPopupShow = true;
				return;
			}
			if (val == '解冻礼品卡') {
				this.thawPopupShow = true;
				return;
			}
			if (val == '批量修改备注') {
				this.remarkPopupShow = true;
				return;
			}
		},
		// 关闭批量备注弹窗
		handleClosePopup() {
			this.remarkPopupShow = false;
			this.selectValue = '';
		},
		// 关闭批量解冻弹窗
		handleCloseThaw() {
			this.thawPopupShow = false;
			this.selectValue = '';
		},
		// 关闭批量冻结弹窗
		handleCloseFrozen() {
			this.frozenPopupShow = false;
			this.selectValue = '';
		},
		//批量修改备注
		handleBatchRemark() {
			let data = {
				act: 'update',
				id: this.selectList.join(','),
				remark: this.batchRemark.trim()
			};
			getGiftRemark(data).then(res => {
				if (res.code == 200) {
					this.getList();
					this.remarkPopupShow = false;
					this.$myAlert({
						title: res.msg
					});
				} else {
					this.remarkPopupShow = false;
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
			// 每次修改 批量选择值为空
			this.selectValue = '';
		},
		//批量解冻礼品卡
		handleBatchThaw() {
			let data = {
				act: 'enable',
				id: this.selectList.join(','),
			};
			getGiftRemark(data).then(res => {
				if (res.code == 200) {
					this.getList();
					this.thawPopupShow = false;
					this.$myAlert({
						title: res.msg
					});
				} else {
					this.thawPopupShow = false;
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
			// 每次修改 批量选择值为空
			this.selectValue = '';
		},
		//批量冻结礼品卡
		handleBatchFrozen() {
			let data = {
				act: 'disable',
				id: this.selectList.join(',')
			};
			getGiftRemark(data).then(res => {
				if (res.code == 200) {
					this.getList();
					this.frozenPopupShow = false;
					this.$myAlert({
						title: res.msg
					});
				} else {
					this.frozenPopupShow = false;
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
			// 每次修改 批量选择值为空
			this.selectValue = '';
		},
		// 底部全选
		handleAll(e) {
			this.$refs.cardTabel.toggleAllSelection(e);
		},
		// 状态、备注筛选
		filterChange(filters) {
			// 每次筛选重置为第一页
			this.pageData.page = 0;
			this.pageData.pagesize = 12;
			// 备注筛选
			if (filters.remark) {
				this.remarkValue = filters.remark.join();
				this.getList();
			}
			// 状态筛选
			if (filters.enable) {
				this.enableValue = filters.enable.join();
				this.getList();
			}
		},
		//获取列表信息
		getList() {
			// 正在请求
			this.submiting == true;

			getGiftCardList({
				sn1: this.sn_start, //序号范围起始值
				sn2: this.sn_end, //序号范围结束值
				remark: this.remarkValue, // 筛选备注值
				enable: this.enableValue, // 筛选状态值
				page: this.pageData.page,
				pagesize: this.pageData.pagesize
			}).then(res => {
				// 请求成功
				this.submiting == false;
				if (res.code == 200) {
					this.list = res.data.data;
					// 分页
					var pager = res.data.pager;
					for (var key in pager) {
						pager[key] = parseInt(pager[key]);
					}
					this.pageData = pager;
				} else {
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
		},
		// 获取选中列表
		handleSelectionChange(val) {
			let list = [];
			if (val && val.length > 0) {
				// 处理选中列表为选中Id列表
				val.map((item, index) => {
					list.push(item.id);
				});
			}
			this.selectList = list; //选中Id列表
			this.allChecked = list.length == this.list.length; //底部全选根据当前页是否全选判断是否选中
		},
		//获取单条备注信息
		handleReviseRemark(val) {
			this.reviseId = val.id;
			if (val.remark) {
				this.oldRemark = val.remark;
			} else {
				this.oldRemark = '';
			}
		},
		// 修改单条备注
		handleRemarkBlur(event) {
			// 判断修改前后值是否为空
			if (event.target.value.trim() == '' && this.oldRemark == '') {
				this.reviseId = ''; // 清除id
				return;
			}
			// 判断修改前后值是否相同
			if (this.oldRemark.trim() == event.target.value.trim()) {
				this.reviseId = ''; // 清除id
				return;
			}
			let data = {
				act: 'update',
				id: this.reviseId,
				remark: event.target.value.trim()
			};
			getGiftRemark(data).then(res => {
				if (res.code == 200) {
					this.getList();
					this.$myAlert({
						title: res.msg
					});
				} else {
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
			this.reviseId = ''; // 清除id
		},
		// 列表切换
		pageChange(page) {
			this.pageData.page = page;
			this.allChecked = false; // 列表切换底部全选为false
			this.getList();
		}
	}
};
</script>

<style scoped>
.search >>> .el-input__inner {
	height: 34px;
	line-height: 14px;
	font-size: 14px;
	padding: 10px 12px;
	/* background-color: #fafbfc; */
}

.list >>> .el-table__body,
.list >>> .el-table__footer,
.list >>> .el-table__header {
	table-layout: auto;
}
.list >>> .operate .cell {
	width: 84px;
	padding-left: 16px;
}
.list >>> .list-header {
	background-color: #fafbfc;
}
.list >>> .list-header .cell {
	line-height: 16px;
}
.pagination >>> button {
	width: 32px;
	height: 32px;
	line-height: 32px;
}
.pagination >>> button .el-icon {
	font-size: 14px;
}
.pagination >>> li {
	width: 32px;
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	font-weight: 400;
	color: #40444d;
	border: 1px solid transparent;
	border-radius: 8px;
	margin: 0 6px;
	padding: 0;
	overflow: visible;
}
.pagination >>> li:hover,
.pagination >>> li.active {
	color: #6681fa;
	font-weight: 600;
	border-color: #6681fa;
	border-left: 1px solid #6681fa;
}

.remarks-tabel >>> input {
	border-width: 0 0 1px 0;
	border-radius: 0;
	padding: 0;
	background-color: transparent;
}
.list >>> input::-webkit-outer-spin-button,
.list >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.list >>> input[type="number"] {
  -moz-appearance: textfield;
}

</style>
<style lang="scss" scoped>
.update {
	width: 100%;
	height: 100%;
	padding: 28px 24px;
	.back-list {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}

	.search {
		display: flex;
		align-items: center;
		justify-content: space-between;
		// margin-top: 0.32px;
		
		.search-left {
			display: flex;
			align-items: center;
		}
		
		.search-title {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #525866;
			line-height: 18px;
		}

		.search-line {
			margin: 0 10px;
			color: #777f8f;
		}
		.el-input {
			width: 165px;
		}
		.el-button {
			width: 104px;
			height: 34px;
			line-height: 34px;
			font-size: 15px;
			padding: 0;
			margin-left: 16px;
			border: none;
			border-radius: 17px;
		}
	}
	.list {
		color: #777f8f;
		margin-top: 16px;

		.iconfont {
			font-size: 12px;

			&.delete-icon {
				position: relative;
				color: #777f8f;

				&::after {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 2px;
					content: '';
					background-color: #ff4c52;
					border-radius: 1px;
					transform: translate(-50%, -50%);
				}
			}
		}
		.update-btn {
			cursor: pointer;
		}
	}
	.pagination {
		margin-left: 200px;
	}

	.remarks-tabel {
		display: flex;
		align-items: center;

		.remarks-val {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #777f8f;
		}

		.remarks-input {
			width: 100px;
		}

		.remarks-icon {
			width: 20px;
			height: 20px;
			margin-left: 10px;
			cursor: pointer;
		}

		.status-tag {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6681fa;
			margin-left: 16px;
			border: none;
			border-radius: 0;
			background-color: transparent;
		}
	}

	.icon-hover {
		color: #6681fa;
	}
}

.status-tip-text {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #777f8f;
	line-height: 24px;
}

.select-cell {
	// position: fixed;
	// bottom: 28px;
	display: flex;
	align-items: center;
	width: 100%;
	height: 66px;
	padding: 0 30px 0 10px;
	background-color: #ffffff;
}

.check-all {
	margin-right: 20px;
}
</style>
